import { Fragment } from 'react';

/**
 * The focal stage's heading, set word by word so the change of pass reads as a
 * sentence being spoken rather than a label being swapped.
 */
export default function ScanBeatHeading({ text }: { text: string }) {
  const words = text.split(' ');

  return (
    <h2
      className="ob-beat__head text-foreground"
      aria-label={text}
      data-testid="onboarding-scan-beat-head"
    >
      {words.map((word, index) => (
        <Fragment key={`${index}-${word}`}>
          {index > 0 ? ' ' : ''}
          <span className="ob-beat__word" style={{ animationDelay: `${index * 55}ms` }}>{word}</span>
        </Fragment>
      ))}
    </h2>
  );
}
